// extracted by mini-css-extract-plugin
export var rateTable = "_4d-0";